/**
 * GUIDED TOUR CONTENT
 *
 * Central export for tour content modules. Add module-specific overrides
 * by re-exporting merged manifests.
 */

export {
  defaultVideoManifest,
  getVideoManifestEntry,
  type VideoManifest,
  type VideoManifestEntry,
} from './videoManifest';

export {
  defaultQuickGuides,
  getQuickGuideOverride,
  type QuickGuideManifest,
} from './quickGuides';
